import { Stack } from "@mui/material";
import React from "react";
import { HubButton } from "../../components";

const OutboundOrdersParts = ({ item }) => {
  const parts = item?.parts.filter(Boolean) || [];
  const max = 2;
  const reduce = parts?.length > max;
  const add = parts?.length - max;
  const buttons = reduce ? parts?.slice(0, max) : parts;

  if (!parts?.length) return <></>;

  return (
    <Stack direction="row" gap="5px">
      {buttons?.map((p, idx) => {
        const label =
          reduce && idx == max - 1
            ? `${p?.partName} +${add}`
            : idx < buttons?.length - 1
            ? `${p?.partName},`
            : p?.partName;

        return (
          <HubButton
            label={label}
            variant="text"
            page={`/parts/${p.id}`}
            size="small"
            sx={{
              ".MuiTypography-root": {
                fontSize: 12,
                fontWeight: 500,
              },
            }}
          />
        );
      })}
    </Stack>
  );
};

export default OutboundOrdersParts;
